import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import PanesHeader from 'modules/core/components/PanesHeader'
import { PanesPad } from 'modules/core/components/PanesPad'
import i18n from 'modules/core/lib/i18n'

import ReviewShowWrapper from 'modules/reviews/components/Show/ReviewShowWrapper'
import Table from 'modules/reviews/components/WriteReviews/Table'

import { useReviewShowContext } from '../hooks'

export default function WriteReviewsPage() {
  const { review } = useReviewShowContext()

  return (
    <ReviewShowWrapper reviewId={Number(review.attributes.id)}>
      <PanesPad>
        <Box gap="s48">
          <PanesHeader
            illustration="surveys"
            title={i18n.t('surveys.review.write_reviews.title')}
            description={i18n.t('surveys.review.write_reviews.description')}
          />
          {review && <Table form={review} />}
        </Box>
      </PanesPad>
    </ReviewShowWrapper>
  )
}
